var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch3Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 2c1.99 0 3.82-.683 5.267-1.828l8.319 8.242L24 24l-.5-2-8.32-8.244A8.5 8.5 0 108.5 17zM11 8.5L8.5 5 6 8.5 8.5 12 11 8.5z",
    fill: "#fff"
  })));
}

export default SvgSearch3Icon;